import React, { useState } from "react";
import { Phone } from "lucide-react";
import { Button } from "./ui/button";
import RappelModal from "./RappelModal";

/**
 * Bouton « Être rappelé » et sa fenêtre de demande.
 *
 * Le bouton portait ce libellé mais composait le numéro : il demandait au
 * visiteur d'appeler, alors qu'il promettait l'inverse. Il ouvre désormais un
 * choix de créneau et c'est nous qui rappelons.
 *
 * L'état de la fenêtre vit ici pour que les pages n'aient qu'à poser le
 * composant, sans gérer d'ouverture ni d'import supplémentaire.
 */
const BoutonRappel = ({
  libelle = "Être rappelé",
  className = "",
  size = "lg",
  variant = "outline",
  avecIcone = true,
}) => {
  const [ouvert, setOuvert] = useState(false);

  return (
    <>
      <Button
        size={size}
        variant={variant}
        className={className}
        onClick={() => setOuvert(true)}
      >
        {avecIcone && <Phone className="mr-2 h-5 w-5" aria-hidden="true" />}
        {libelle}
      </Button>
      <RappelModal isOpen={ouvert} onClose={() => setOuvert(false)} />
    </>
  );
};

export default BoutonRappel;
